import { useCallback, useState, useEffect, useRef, useMemo } from "react";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { FormInstance } from "antd";

import { APP_PART_TYPES } from "../AppForm/constants";
import { ItemConfigDataType } from "@lhd/features/Apps/AppForm/types";
import {
  getPrimaryCompanyNameDisplayText,
  isEmployeeInfoChildAppPartType,
} from "../utils";
import AutoFill from "../components/AutoFill";
import EmployeeInfoChildField from "../components/EmployeeInfoChildField";

import { flatMapDeep, pick } from "lodash";
import Attachment from "../components/Attactment";
import RichText from "../components/RichText";
import { AppSelectionList } from "@lhd/types";
import InputNumber from "../components/InputNumber";
import TextAreaCustom from "../components/TextAreaCustom";
import LinkCusTom from "../components/LinkCusTom";
import DateAndTime from "../components/DateAndTime";
import DateCustom from "../components/DateCustom";
import TimeCustom from "../components/TimeCustom";
import Dropdown from "../components/Dropdown";
import CommonSelection from "../components/CommonSelection";
import CheckBox from "../components/CheckBox";
import CommonChoose from "../components/CommonChoose";
import Text from "../components/Text";
import RadioButton from "../components/RadioButton";
import EmployeeSignature from "../components/EmployeeSignature";

interface IEditColumn {
  indexRow: number;
  child: AppPartType;
  record: any;
  form: FormInstance<any>;
  setEditorState: any;
  editorState: ObjectType;
  listFileUploaded: any[];
  setListFileUploaded: (valure: any) => void;
  parentRecord: AppPartType;
  isDisable?: boolean;
  isAllowEditColumn?: boolean;
  listUpdateAllowDownload?: any;
  setListUpdateAllowDownload?: React.Dispatch<any>;
  setListFileRemove?: React.Dispatch<any>;
  listFileRemove?: any;
  setAllowDownLoad: React.Dispatch<any>;
  allowDownLoad: any;
  selectionDataList: AppSelectionList;
  isPreview?: boolean;
  isShareRecord?: boolean;
}
type ObjectType = {
  [key: string]: any;
};

const RenderEditColumn = ({
  indexRow,
  child,
  record,
  form,
  setEditorState,
  listFileUploaded,
  setListFileUploaded,
  parentRecord,
  isDisable = false,
  isAllowEditColumn,
  setListUpdateAllowDownload,
  listUpdateAllowDownload,
  setListFileRemove,
  listFileRemove,
  setAllowDownLoad,
  allowDownLoad,
  selectionDataList,
  isPreview,
  isShareRecord,
  ...restProps
}: IEditColumn) => {
  const item = child;
  const minChar = item.item_config_data.min_num_char;
  const maxChar = item.item_config_data.max_num_char;
  const item_config_data: ItemConfigDataType = item.item_config_data;
  const nameItem = `${record.key}-${item.id}`;
  const flattenDeepArray: any = useCallback((originalArray: any) => {
    return flatMapDeep(originalArray, (item) => {
      const transformedItem = pick(item, ["id", "name"]);
      const children = item.children || [];

      return [transformedItem, ...flattenDeepArray(children)];
    });
  }, []);

  /* eslint-disable */
  const commonProps = {
    key: item.id,
    isTable: true,
    preview: isPreview,
    isDisable: isDisable,
    item: item,
    parentItem: parentRecord,
    nameItem: nameItem,
    isShareRecord: isShareRecord,
  };

  switch (item.app_part_type) {
    case APP_PART_TYPES.TEXT:
      return <Text {...commonProps} />;
    case APP_PART_TYPES.TEXT_AREA:
      return <TextAreaCustom {...commonProps} />;
    case APP_PART_TYPES.RICH_TEXT:
      return (
        <div id={nameItem}>
          <RichText
            {...commonProps}
            onChange={(state) => setEditorState(state)}
          />
        </div>
      );
    case APP_PART_TYPES.NUMBER:
      return (
        <div>
          <InputNumber {...commonProps} />
        </div>
      );
    case APP_PART_TYPES.RADIO_BUTTON:
      return <RadioButton {...commonProps} />;
    case APP_PART_TYPES.CHECK_BOX:
      return <CheckBox {...commonProps} />;
    case APP_PART_TYPES.MULTI_CHOICE:
    case APP_PART_TYPES.RELATED_RECORDS:
      return <CommonChoose {...commonProps} />;
    case APP_PART_TYPES.DROPDOWN:
      return <Dropdown {...commonProps} />;
    case APP_PART_TYPES.DATE:
      return <DateCustom {...commonProps} />;
    case APP_PART_TYPES.TIME:
      return <TimeCustom {...commonProps} />;
    case APP_PART_TYPES.DATE_AND_TIME:
      return <DateAndTime {...commonProps} />;
    case APP_PART_TYPES.LINK:
      return <LinkCusTom {...commonProps} />;
    case APP_PART_TYPES.ATTACHMENT:
      return (
        <div key={item.id}>
          <Attachment
            form={form}
            item={parentRecord}
            isDisable={isDisable}
            isHiddleLabel={true}
            listFileUploaded={listFileUploaded}
            setListFileUploaded={setListFileUploaded}
            listUpdateAllowDownload={listUpdateAllowDownload}
            setListUpdateAllowDownload={setListUpdateAllowDownload}
            isAllowEditColumn={isAllowEditColumn || true}
            listFileRemove={listFileRemove}
            setListFileRemove={setListFileRemove}
            nameField={nameItem}
            isTable
            multiple={false}
            setAllowDownLoad={setAllowDownLoad}
            allowDownLoad={allowDownLoad}
          />
        </div>
      );
    case APP_PART_TYPES.ORGANIZATION_SELECTION:
    case APP_PART_TYPES.DIVISION_SELECTION:
    case APP_PART_TYPES.DEPARTMENT_SELECTION:
    case APP_PART_TYPES.BRANCH_SELECTION:
    case APP_PART_TYPES.WORKER_SELECTION:
    case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
    case APP_PART_TYPES.REPRESENTATIVE_SELECTION:
    case APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION:
    case APP_PART_TYPES.POSITION_SELECTION:
    case APP_PART_TYPES.EMPLOYEE_INFO_SELECTION:
    case APP_PART_TYPES.CUSTOMER_SELECTION:
      return (
        <CommonSelection
          selectionDataList={selectionDataList}
          {...commonProps}
        />
      );
    case APP_PART_TYPES.PRIMARY_COMPANY_NAME:
      return (
        <AutoFill {...commonProps}>
          {getPrimaryCompanyNameDisplayText()}
        </AutoFill>
      );
    case APP_PART_TYPES.CREATED_BY:
    case APP_PART_TYPES.UPDATED_BY:
    case APP_PART_TYPES.CREATED_DATETIME:
    case APP_PART_TYPES.UPDATED_DATETIME:
      return <AutoFill {...commonProps} />;

    case APP_PART_TYPES.RECORD_NUMBER: {
      return <AutoFill {...commonProps}>{indexRow + 1}</AutoFill>;
    }
    case APP_PART_TYPES.EMPLOYEE_SIGNATURE:
      return (
        <EmployeeSignature
          {...commonProps}
          form={form}
          selectionDataList={selectionDataList}
        />
      );
    default:
      if (isEmployeeInfoChildAppPartType(item.app_part_type)) {
        return (
          <EmployeeInfoChildField
            {...commonProps}
            appParts={parentRecord?.children}
            form={form}
          />
        );
      }
      return <div></div>;
  }
};
export default RenderEditColumn;
